import { LoadingOutlined, UpOutlined } from '@ant-design/icons';
import {AddCircleSharp, ArrowDownward, RemoveCircle, Close} from '@mui/icons-material';



import { Button, Checkbox, Dropdown, Modal, Space, Spin } from 'antd';
import AnimatedCheckMark from "components/AnimatedCheckMark";
import AssignmentForm from "features/forms/AssignmentForm";
import React, { useEffect, useMemo, useRef, useState, useCallback } from "react";
import { useAllBook } from "store/books/selectors";
import { useResources } from "store/resources/selectors";
import { getNumberMask, isVideo } from "utils/lib/ebookHelper";
import { getRandomCotation } from 'utils/methods/math';
import styled from 'styled-components';
import { question_type_generate_more } from 'utils/config/reference';
import { DownOutlined } from '@ant-design/icons';
import * as Sentry from '@sentry/react';
import SkeletonWrittenResponse from 'components/UI/Skeltonloader/SkeletonWrittenResponse';
import { useUI } from 'store/UI/selectors';
import AIUsageInfo from 'components/Modals/AiInfoModal';
import usePopUpAtOnce from 'components/hooks/usePopUpAtOnce';
import SentryWrap from 'components/Sentry';
import ClickOutside from 'components/OnClickOutside';
const btnpurple="rgba(86,29,223)"
var quata_change_interval =null;
const questionTypeMap = {
    multipleChoice: 'Multiple Choice',
    trueFalse: 'True or False',
    essay: 'Written Response',
    filling: 'Fill in the Blanks',
};

const TextAuthor= styled.span`
    color:#fff;
    font-size: 14px;
    font-weight: 400;
    align-self: center;
    text-align: right;
    background-color: ${btnpurple};
    border-radius: 12px;
    padding: 2px 24px;
    margin-top:10px;
    min-width:100px;
    `;

const TextContainer = styled.div`
    display: flex;
    flex-direction:column;
    justify-content:center;
    align-items: flex-end;
    width: 100%;
    padding: 0px 16px;
`;
const MessageWrapper = styled.div `
    max-width:450px;
    padding: 10px;
`
const TextMessage = styled.span`
    color:#fff;
    font-size: 18px;
    font-weight: 600;

    @media (max-width: 992px) {
        font-size: 14px;
    }
`;
const QuetaArea = styled.div`
    // background: #3c1262;
    background-image: linear-gradient(to right, #510a49, #042f72) !important;
    width: auto;
    margin: 0 auto;
    text-align: center;
    padding: 12px 12px;
    display: flex;
    justify-content: center;
    align-items: center;
    min-height: 120px;
    border-radius: 56px;
    // &:hover {
    //     background-image: linear-gradient(to right, #510a49, #042f72) !important;
    // }
`;
const QnALoader = ({ 
    assignmentAiModal, 
    setAssignmentAiModal, 
    generateQnALoader, 
    questionGenerator = [], 
    page, 
    chapter, 
    pageSrc,
    handleGenerateMoreQnA,
    from='',
    assignmentTitle,
    qnaWord,
    loading,
    pageNumber,
    selectedTypes = [],
    setSelectedTypes = (types) => {},
    openWith = '',
    storyInstruction = '',
    article_level_id = '',
    generatedCount=0,
    setQuestionGenerator=() =>{},
    uniqueKeyAssignmentAi,
    onAddQuestionsToAssignment = () => {},
    resourceKeyAssignmentAi,
    modalZIndex = null,
    onClose = () => {},
    dismissAssignmentAiParentOnSave = false
 }) => {
    const booksAllList = useAllBook();
    const resources = useResources();
    const [selected, setSelected] = useState([]);
    const [topic, setTopic] = useState(qnaWord);
    const [openEditModal, setEditModal] = useState(false);
    const { quotesData = [] } = useUI();
    const [quatation,setQuatation] = useState(getRandomCotation(quotesData));
    const [open, setOpen] = useState(false);
    const containerRef = useRef();
    const [showJumpButton, setShowJumpButton] = useState(false);
    const prevGeneratedCountRef = useRef(generatedCount);
    const [newItemIds, setNewItemIds] = useState([]);
    const {updatePopUpAtOnce} = usePopUpAtOnce();
    const [selectedLanguage, setSelectedLanguage] = useState('spanish');
    const [allSelected, setAllSelected] = useState(false);

    const checkIfAtBottom = useCallback(() => {
        const container = containerRef.current;
        if (container) {
            const isAtBottom = container.scrollHeight - container.scrollTop <= container.clientHeight + 50;
            return isAtBottom;
        }
        return false;
    }, []);

    const handleScroll = useCallback(() => {
        const container = containerRef.current;
        if (container) {
            const isAtBottom = checkIfAtBottom();
            if (!isAtBottom && container.scrollHeight > container.clientHeight) {
                setShowJumpButton(true);
            } else {
                setShowJumpButton(false);
            }
        }
    }, [checkIfAtBottom]);

    useEffect(() => {
        const container = containerRef.current;
        if (container) {
            container.addEventListener('scroll', handleScroll);
            handleScroll();
            return () => container.removeEventListener('scroll', handleScroll);
        }
    }, [questionGenerator, assignmentAiModal, handleScroll]);

    useEffect(() => {
      if (generatedCount > prevGeneratedCountRef.current) {
        const newIds = Array.isArray(questionGenerator) ? questionGenerator
          .slice(prevGeneratedCountRef.current)
          .map((q) => q.id || q.question) : [];
    
        setNewItemIds(newIds);
    
        const container = containerRef.current;
        if (container && container.scrollHeight - container.scrollTop > container.clientHeight + 300) {
          setShowJumpButton(true);
        }
    
        setTimeout(() => {
          setNewItemIds([]);
        }, 3000);
      }
      prevGeneratedCountRef.current = generatedCount;
    }, [generatedCount]);
      

    useEffect(() => {
        if (quata_change_interval) {
            clearInterval(quata_change_interval);
        }
        quata_change_interval = setInterval(() => {
            setQuatation(getRandomCotation(quotesData))
        }, 6000);
        return () => clearInterval(quata_change_interval);
    }, [])
    const numberMasked = useMemo(() => {
        if (isVideo(chapter, resources)) return null;
        if (pageNumber) return pageNumber;
        return getNumberMask(chapter, page, booksAllList);
    }, [chapter, page, booksAllList, resources]);

    useEffect(() => {
        setTopic(qnaWord);
    }, [qnaWord])

    const textInputDisableCheck = (text) => {
        try {
            if (typeof text !== 'string') return true;
            const cleanedAnswer = text.replace(/<[^>]*>/g, '')
                .replace(/\s/g, '')
                .replace(/&[^;]+;/g, '')
                .replace(/[<>&]/g, '')
                .trim();
            const hasAlphanumeric = /[a-zA-Z0-9]/.test(cleanedAnswer);
            return !hasAlphanumeric;
        } catch (error) {
            Sentry.captureException(`396 Error in textInputDisableCheck: ${error}`);
            console.error("Error in textInputDisableCheck:", error);
            return true;
        }
    };

    const handleWordLimit = (text) => {
        setTopic(text);
    }
    const toggleSelectAll = () => {
        setAllSelected(!allSelected);
        if(!allSelected){
            setSelected(questionGenerator);
        }else{
            setSelected([]);
        }
    }

    useEffect(() => {
        if(allSelected){
            setSelected(questionGenerator);
        }
    }, [allSelected, questionGenerator])

    useEffect( () => {
        if(selected.length === questionGenerator.length){
            setAllSelected(true);
        }else{
            setAllSelected(false);
        }
    }, [selected, questionGenerator])

    const handleButtonClick = (id) => {
        const selectedQuestion = questionGenerator.find(question =>question.id === id);
        setSelected((prevSelected) => {
            const questionIndex = prevSelected?.findIndex((question) => question.id === id);
            let updatedSelected;
        
            if (questionIndex === -1) {
                updatedSelected = [...prevSelected, selectedQuestion];
            } else {
                updatedSelected = [...prevSelected];
                updatedSelected.splice(questionIndex, 1);
            }
            return updatedSelected;
        });
    }

    const handleCreateAssignment =async () => {
        setSelected(selected);
        setEditModal(true);
        setAssignmentAiModal(true);   
    }
    const handleAddToExistingAssignment =async () => {
        const selectedLength = selected?.length || 0
        if (!selectedLength) {
            return
        }
        try {
            await Promise.resolve(onAddQuestionsToAssignment(selected))
        } catch (error) {
            Sentry.captureException(`264 Error in handleAddToExistingAssignment: ${error}`);
        } finally {
            setAssignmentAiModal(false)
            if (typeof onClose === 'function') {
                onClose();
            }
        }
    }
    const selected_length = selected?.length || 0


    const handleCheckboxChange = (value, e) => {
      e.stopPropagation();
      e.preventDefault();
      setSelectedTypes((prev) => {
        if (prev.includes(value)) {
          return prev.filter((type) => type !== value);
        }
        return [...prev, value];
      });
    };

    const menu = {
        items: question_type_generate_more.map((option, index) => ({
          key: index,
          label: (
            <div onClick={(e) => e.stopPropagation()}>
              <Checkbox
                checked={selectedTypes.includes(option.value)}
                onChange={(e) => handleCheckboxChange(option.value, e)}
                onClick={(e) => e.stopPropagation()}
              >
                {option.label}
              </Checkbox>
            </div>
          ),
          onClick: (e) => {
            if (e && e.domEvent) {
              e.domEvent.stopPropagation();
              e.domEvent.preventDefault();
            }
          }
        })),
      };

      useEffect(()=>{
        if(!generateQnALoader && assignmentAiModal){
            setSelected([]);
        }
      },[generateQnALoader , assignmentAiModal])

      const handleGenerateMore = async ({key}) => {
        if (loading) return;
        if(from=='ai_image'){
            return handleGenerateMoreQnA(topic,key)
        }
        if (topic.trim() !== '') {
            await handleGenerateMoreQnA(topic,key)
        }
      }

      const [openLanguageDropdown, setOpenLanguageDropdown] = useState(false);

    return (<SentryWrap>
        <div>
            <Modal open={generateQnALoader && assignmentAiModal}
                className={`scenMdlWrapCstm scenarioMdlWrapNew gmScenarioSecond`}
                closable={false}
                {...(modalZIndex ? {zIndex: modalZIndex} : {})}
            >
                <div className='yourMagic'>
                    <div className='yourMagicImg'>
                        <img
                            src={'https://firebasestorage.googleapis.com/v0/b/yo-americano.appspot.com/o/AI_Topic.png?alt=media&token=e1a09441-0c55-4be0-a545-d0a579f8d7222'}
                            alt=''
                        />
                    </div>
                    <QuetaArea>
                        <TextContainer smallmsg={quatation?.size === "sml"} longAuthor={quatation?.author === "Selena Quintanilla-Pérez, cantante y compositora"}>
                            <MessageWrapper>
                                <TextMessage className='animate__animated animate__pulse'>{quatation?.message}</TextMessage>
                            </MessageWrapper>
                            {quatation?.author && <TextAuthor longAuthor={quatation?.author === "Selena Quintanilla-Pérez, cantante y compositora"} >- {quatation?.author}</TextAuthor>}
                        </TextContainer>
                    </QuetaArea>
                    <div className='maginSpinner'>
                        <Spin
                            size='large'
                            indicator={
                                <div className='magicIndicator'>
                                    <div className='dot' />
                                    <div className='dot' />
                                    <div className='dot' />
                                    <div className='dot' />
                                </div>
                            }
                        />
                    </div>
                </div>
            </Modal>

            <Modal
                open={!generateQnALoader && assignmentAiModal}
                onCancel={() => {
                    updatePopUpAtOnce(false);
                    setSelected([]);
                    setQuestionGenerator([]);
                    setSelectedTypes(question_type_generate_more.map(opt => opt.value));
                    setAssignmentAiModal(false)
                   
                }}
                className={`scenMdlWrapCstm scenarioMdlWrapNew gmScenarioSecond`}
                maskClosable={false}
                {...(modalZIndex ? {zIndex: modalZIndex} : {})}
            >
                <div className='writeTpcUpr'>
                    <div className='createBckBtn text-dark' style={{ justifyContent: 'space-between' }}>
                        <span>AI Creator</span>
                        <AIUsageInfo />
                    </div>
                    <div className='writeTpcEbk writeTpcEbkSection'>
                        <p>Your questions are ready for your selection!</p>
                        <img
                            src={'https://firebasestorage.googleapis.com/v0/b/yo-americano.appspot.com/o/AI_Topic.png?alt=media&token=e1a09441-0c55-4be0-a545-d0a579f8d7222'}
                            alt=''
                        />
                    </div>
                    <div className='generateMore'>
                        <div className='subGenerateMore'>

                            <textarea
                                className='AIFieldMore'
                                onKeyDown={async (e) => {
                                    if (textInputDisableCheck(topic) || loading) return;
                                    if (e.key === 'Enter' && !e.shiftKey && topic.trim() !== '') {
                                        e.preventDefault()
                                        await handleGenerateMoreQnA(topic)
                                    }
                                }}
                                onChange={(e) => {
                                    handleWordLimit(e.target.value)
                                }}
                                value={from=='ai_image'?(assignmentTitle||'Questions generation from pages'):topic}
                                type='text'
                                disabled
                                placeholder='Write your topic or choose one from below'
                            />

                            <div className='subGenerateBtns'>
                            {openWith !== 'story_ai' && (
                             <Dropdown
                                 menu={menu}
                                 trigger={['click']}
                                 open={open}
                                 onOpenChange={(visible) => {
                                     setOpen(visible);
                                 }}
                                 getPopupContainer={(trigger) => trigger.parentElement}
                                 popupRender={(menu) => (
                                    <ClickOutside onClickOutside={() => setOpen(false)}>
                                     <QnaLoaderQuestionType 
                                         className='qna-loader-question-type'
                                         onClick={(e) => e.stopPropagation()}
                                     >
                                     <div style={{ 
                                         display: 'flex', 
                                         justifyContent: 'space-between', 
                                         alignItems: 'center', 
                                         padding: '8px 12px',
                                         borderBottom: '1px solid #f0f0f0' 
                                     }}>
                                         <span style={{ fontWeight: 500, fontSize: '14px' }}>Question Types</span>
                                         <Close 
                                             style={{ cursor: 'pointer', fontSize: '20px',color: 'red' }} 
                                             onClick={(e) => {
                                                 e.stopPropagation();
                                                 setOpen(false);
                                                 if(typeof onClose === 'function'){
                                                    onClose();
                                                 }
                                             }}
                                         />
                                     </div>
                                     <Space direction="vertical" onClick={(e) => e.stopPropagation()}>
                                         {menu}
                                         <div className='flex items-center w-full gap-10px' style={{ borderTop: '1px solid #f0f0f0', padding: '8px 0 0', paddingInline: '5px' , paddingBottom:8 }}>
                                         <Button
                                             type="link"
                                             size="small"
                                             onClick={(e) => {
                                                 e.stopPropagation();
                                                 setSelectedTypes(question_type_generate_more.map(opt => opt.value));
                                             }}
                                             style={{width: '86px', height: '30px'}}
                                         >
                                             Select All
                                         </Button>
                                         <Button
                                             type="link"
                                             size="small"
                                             onClick={(e) => {
                                                 e.stopPropagation();
                                                 setSelectedTypes([]);
                                             }}
                                             style={{width: '86px', height: '30px'}}
                                         >
                                             Clear All
                                         </Button>
                                         </div>
                                        </Space>
                                     </QnaLoaderQuestionType>
                                    </ClickOutside>
                                 )}
                                 >
                                 <Button>
                                     Question Types ({selectedTypes.length}) {open ? <UpOutlined style={{ fontSize: '16px' }} /> : <DownOutlined style={{ fontSize: '16px' }} />}
                                 </Button>
                                 </Dropdown>
                            )}
                             <Dropdown
                               open={openLanguageDropdown}
                               onOpenChange={setOpenLanguageDropdown}
                                menu={{
                                    items: [
                                        {
                                            key: 'spanish',
                                            label: 'Spanish',
                                            onClick: (e) => handleGenerateMore(e)
                                        },
                                        {
                                            key: 'english',
                                            label: 'English',
                                            onClick: (e) => handleGenerateMore(e)
                                        }
                                    ]
                                }}
                                trigger={['click']}
                            >
                            <Button
                                className='gmAI'
                                style={{ marginLeft: 10 }}
                                disabled={generatedCount > 0 ? true : from!='ai_image' ? textInputDisableCheck(topic) : false}
                            >
                                Generate more
                                {openLanguageDropdown ? <UpOutlined style={{ fontSize: '16px' }} /> : <DownOutlined style={{ fontSize: '16px' }} />}
                                {loading ? (
                                    <Spin
                                        indicator={
                                            <LoadingOutlined
                                                style={{ fontSize: 24, color: 'white', marginLeft: '10px' }}
                                                spin
                                            />
                                        }
                                    />
                                ) : (
                                    ''
                                )}
                            </Button>

                            </Dropdown>

                            <Button
                                onClick={toggleSelectAll}
                                style={{ marginLeft: 10 }}
                                className="defaultButton"
                                // disabled={is_selected}
                            >
                                {allSelected ? 'Deselect All' : 'Select All'}{' '}
                                {allSelected ? (
                                    <RemoveCircle />
                                ) : (
                                    <AddCircleSharp />
                                )}
                            </Button>



                          
                            </div>

                        </div>
                    </div>
                    <div className='quesSelect' ref={containerRef}>
                        <div style={{ marginTop: 20, marginBottom: 20 }}>
                            {questionGenerator && Array.isArray(questionGenerator) &&
                                questionGenerator.map((question, index) => {
                                    const id = question.id || index
                                    const is_selected =  selected?.some((item) => item.id === id);
                                    return (
                                        <div key={id} className='quesSelectTxt'>
                                            <div className='questionContainer'>
                                                <Button
                                                    onClick={(e) => {
                                                        handleButtonClick(question.id)
                                                    }}
                                                    className={
                                                        is_selected?'greenButton' : 'defaultButton'
                                                    }
                                                    // disabled={is_selected}
                                                >
                                                    {is_selected ? 'Selected' : 'Select'}{' '}
                                                    {is_selected ? (
                                                        <RemoveCircle />
                                                    ) : (
                                                        <AddCircleSharp />
                                                    )}
                                                </Button>

                                                <p
                                                    style={{
                                                        position: 'absolute',
                                                        top: -14,
                                                        padding: '0px 10px',
                                                        background: 'white',
                                                        borderRadius: 25,
                                                        color: 'black',
                                                        fontSize: 15,
                                                    }}
                                                >
                                                    {questionTypeMap[question?.type] || ''}
                                                </p>
                                                <p>
                                                    {index + 1}. {question.question}
                                                </p>
                                                {(question.type === 'trueFalse' || question.type === 'multipleChoice') && (
                                                    <div className='optionsContainer'>
                                                        {Array.isArray(question.options) && question.options.map((option, optionIndex) => (
                                                            <p key={optionIndex} className="optionsContainerCheck">
                                                                {String.fromCharCode(65 + optionIndex)}. {option}
                                                                {(question.answer_text === option ||
                                                                    question.answerText === option) && (
                                                                        <AnimatedCheckMark style={{ marginLeft: "5px" }} />
                                                                    )}
                                                            </p>
                                                        ))}
                                                    </div>
                                                )}
                                                {['essay'].includes(question.type) && (
                                                    <div className='optionsContainer'>
                                                        <p>Answer: {question.answer_text || question.answerText}</p>
                                                    </div>
                                                )}
                                                {question.type === 'filling' && (
                                                    <div>
                                                        {question && Array.isArray(question.options) && question.options.map((option, optionIndex) => {
                                                            const words = question.highlightWords[optionIndex];
                                                            const selectedAnswers = question.answerSelected[optionIndex] || [];

                                                            let currentIndex = 0;

                                                            // Build the text with blanks
                                                            const renderedOption = Array.isArray(words) ? words.map((word, wordIndex) => {
                                                                const beforeText = option.slice(currentIndex, word.start); // Text before the blank
                                                                const blankAnswer = selectedAnswers[wordIndex]?.text || "";
                                                                currentIndex = word.end;

                                                                return (
                                                                    <span key={wordIndex}>
                                                                        {beforeText}
                                                                        <span
                                                                            style={{
                                                                                display: "inline-block",
                                                                                minWidth: "50px",
                                                                                textAlign: "center",
                                                                                borderBottom: "1px solid white",
                                                                                margin: "0 4px",
                                                                                color: "#fff",
                                                                            }}
                                                                        >
                                                                            {blankAnswer}
                                                                        </span>
                                                                    </span>
                                                                );
                                                            }) : [];

                                                            // Add the remaining text after the last blank
                                                            const afterText = option.slice(currentIndex);

                                                            return (
                                                                <div key={optionIndex} style={{ marginBottom: "20px" }}>
                                                                    <div style={{ color: 'white' }}>
                                                                        {renderedOption}
                                                                        {afterText}
                                                                    </div>
                                                                    <div style={{ marginTop: "10px", color: 'white' }}>
                                                                        <span>Answers: </span>
                                                                        <span>{ Array.isArray(selectedAnswers) ? selectedAnswers.map((ans) => ans.text).join(", ") : ''}</span>
                                                                    </div>
                                                                </div>
                                                            )
                                                        })}
                                                    </div>
                                                )}
                                            </div>
                                        </div>
                                    )
                                })}
                           {generatedCount > 0? <SkeletonWrittenResponse/>:null}
                        </div>
                    </div>
                    <div className='allCreateBtn createSelectedTxt'>
                        {showJumpButton && (
                          <Button
                            className={'greenButton'}
                            style={{
                                display: 'flex',
                                justifyContent: 'center'
                            }}
                            onClick={() => {
                              containerRef.current?.scrollTo({
                                top: containerRef.current.scrollHeight,
                                behavior: 'smooth',
                              });
                              setShowJumpButton(false);
                            }}
                          >
                            {`See More`} <ArrowDownward fontSize='19px' />
                          </Button>
                        )}
                        {selected_length > 0 && (
                            <div className='createBckBtn text-dark' style={{marginRight: '5px'}}>
                                {`Selected ${selected_length}`}
                            </div>
                        )}
                        <Button
                            onClick={(e) => {
                                if(uniqueKeyAssignmentAi){
                                    handleAddToExistingAssignment()
                                } else {
                                    handleCreateAssignment()
                                }
                                
                            }}
                            className={'greenButton'}
                            disabled={selected_length === 0}
                        >
                            {uniqueKeyAssignmentAi ? 'Add To Assignment' : 'Create Assignment'}
                        </Button>
                    </div>
                </div>
            </Modal>
            {openEditModal && <AssignmentForm
                open={openEditModal}
                onClose={() => {
                    updatePopUpAtOnce(false);
                    setEditModal(false);
                    setAssignmentAiModal(false);
                    setSelectedTypes(question_type_generate_more.map(opt => opt.value));
                }}
                onCloseEntireAiFlow={dismissAssignmentAiParentOnSave ? onClose : undefined}
                setAssignmentAiModal={setAssignmentAiModal}
                bookId={chapter}
                pageId={resourceKeyAssignmentAi ? null : page}
                pageSrc={pageSrc}
                assignmentTitle={assignmentTitle || `${from === 'phrases' ? 'Phrases' : from === 'cognates' ? 'Cognate' : 'Vocab'} Activity  ${numberMasked ? `Pg. ${numberMasked}` : ''}`} 
                ai_questions={selected}
                storyInstruction={storyInstruction}
                article_level_id={article_level_id}
                formResource={resourceKeyAssignmentAi ? 'resource' : ''}
            />}
        </div>
        </SentryWrap>)
}
export default QnALoader;

const QnaLoaderQuestionType = styled.div`
    background-color: white; 
    padding: 8;
    border-radius: 6px;
`;